import { AttachmentModule } from '../attachment/attachment.module';

/**
 * Moduł załączników procedury
 *
 * @export
 * @class ProcedureAttachmentModule
 * @extends {AttachmentModule}
 */
export class ProcedureAttachmentModule extends AttachmentModule {}

export default new ProcedureAttachmentModule();
